import { useState } from "react";
import { useApi } from "./useApi";
import { useTranslation, Trans } from "react-i18next";
import { EMAIL_PATTERN, normalizeEmail } from "./normalizeEmail";

export const useSendTestMail = () => {
  const { t, i18n } = useTranslation();
    const [isLoading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const isError = error !== null;

    const sendTestMail = async (targetEmail: string): Promise<boolean> => {
      if (!targetEmail) {
        alert(t("メールアドレスを正しくご入力ください。"));
        return false;
      }

      // 入力欄と同じ条件でチェックする（issue #3302）
      // 入力欄でエラーになる値でもこのボタンは押せてしまうため、ここでも同じ EMAIL_PATTERN を使う
      const normalizedEmail = normalizeEmail(targetEmail);
      if (!EMAIL_PATTERN.test(normalizedEmail)) {
        alert(t("メールアドレスを正しくご入力ください。"));
        return false;
      }

      const confirm = window.confirm(t("このメールアドレスにテストメールを送信します。よろしいですか？") ?? "このメールアドレスにテストメールを送信します。よろしいですか？");
      if (!confirm) {
        return true;
      }

      setLoading(true);

      try {
        const response = await useApi.post({
          url: "/testMail",
          data: {
            address: normalizedEmail,
            language_code: i18n.language,
          }
        })

        if (response.status !== 200) {
          throw new Error("送信に失敗しました。");
        }

        alert(t("テストメールを送信しました。メールが受信できているかご確認ください。"));

        setLoading(false);

        return true;

      } catch (error) {
        setError("送信に失敗しました。");
        alert("テストメールの送信に失敗しました。しばらくしてから再度お試しください。");
      }

      setLoading(false);

      return false;
    }

    return [ sendTestMail, { isLoading, isError, error } ] as const;
};